import type {HideableValue, Values} from '@wix/devzai-utils-common';
import {evaluateFunction, hideableValueGetValue, hideableValueIsVisible} from '@wix/devzai-utils-common';

export const DoppeActionListItemClickBehaviour = {
    PreviewItem: 'PreviewItem',
    OpenLink: 'OpenLink',
    PreviewItemAsPopup: 'PreviewItemAsPopup',
    None: 'None',
} as const;

export type DoppeActionListItemClickBehaviour = Values<typeof DoppeActionListItemClickBehaviour>;

/**
 * Whether the given click behaviour opens an item preview (inline or popup).
 * Returns false for OpenLink and None, where no expanded item view is shown.
 */
export function doppeActionListItemClickBehaviourHasItemPreview(
    itemClickBehaviour: DoppeActionListItemClickBehaviour
): boolean {
    return evaluateFunction(() => {
        switch (itemClickBehaviour) {
            case DoppeActionListItemClickBehaviour.PreviewItem:
            case DoppeActionListItemClickBehaviour.PreviewItemAsPopup:
                return true;
            case DoppeActionListItemClickBehaviour.OpenLink:
            case DoppeActionListItemClickBehaviour.None:
                return false;
        }
    });
}

/**
 * Resolves the effective click behaviour for a list item, considering the per-item override.
 * If the item has a visible (custom) click behaviour, it is used; otherwise the list-level default is used.
 */
export function doppeActionListItemResolveEffectiveClickBehaviour(
    listItemClickBehaviour: HideableValue<DoppeActionListItemClickBehaviour>,
    listLevelClickBehaviour: DoppeActionListItemClickBehaviour
): DoppeActionListItemClickBehaviour {
    return hideableValueIsVisible(listItemClickBehaviour)
        ? hideableValueGetValue(listItemClickBehaviour)
        : listLevelClickBehaviour;
}
